module.exports = __webpack_public_path__ + "static/media/printStep1.06432554.png";